// extracted by mini-css-extract-plugin
export default {"container":"ImagePart_container__9CRdI","image":"ImagePart_image__bzrt6"};